<!-- DESKTOP VIEW -->
<div class="border rounded visibleDesktop">
  <div class="col-sm-6">
    <div class="row ml-n1 h-35">
      <div class="col-12 h-19 d-flex align-items-center border-bottom divLeft-n1">
        <div class="row ml-1 margin-top-bottom">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1" [icon]="['far', 'envelope-open-text']"></fa-icon>
            {{ "titleEnvelope" | translate }}:
          </h4>
          <div class="col-11 ml-1 gray-70 wrap small">
            {{ generalInformationModal?.value['titleEnvelope'] }}
          </div>
        </div>
      </div>
      <div class="col-6 h-17 d-flex align-items-center border-bottom divLeft-n1">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1" [icon]="['far', 'globe']"></fa-icon>
            {{ "language" | translate | titlecase }}:&nbsp;
          </h4>
          <div class="gray-70 small">
            {{ generalInformationModal?.value['language']?.value }}
          </div>
        </div>
      </div>
      <div class="col-6 h-17 d-flex align-items-center border-bottom border-bottom-dotted">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1" [icon]="['far', 'hourglass-half']"></fa-icon>
            {{ "expiration" | translate | titlecase }}:&nbsp;
          </h4>
          <div class="gray-70 small">
            {{ generalInformationModal?.value['expiration']?.singleDate?.formatted ? generalInformationModal?.value['expiration']?.singleDate?.formatted
            : 'noneExpiration' | translate | titlecase }}
          </div>
        </div>
      </div>
      <div class="col-12 h-17 d-flex align-items-center border-bottom">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1" [icon]="['far', 'key']"></fa-icon>
            {{ "authentication" | translate }}:&nbsp;
          </h4>
          <div class="gray-70 small">
            {{ accessAuthenticationText | titlecase}}
          </div>
        </div>
      </div>
      <div class="col-12 h-25 d-flex align-items-center divLeft-n1" [class.border-bottom]="!isSignFreemium">
        <div class="row ml-1 margin-top-bottom">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1" [icon]="['far', 'file-alt']"></fa-icon>
            {{ "documents" | translate | titlecase }}:
          </h4>
          <div class="row documents">
            <div class="col-11 ml-1 gray-70 wrap small"
              *ngFor="let file of generalInformationModal?.value['archives']">
              {{ file.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 h-19 d-flex align-items-center" *ngIf="!isSignFreemium">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1" [icon]="['far', 'folder']"></fa-icon>
            {{ "segment" | translate | titlecase }}:&nbsp;
          </h4>
          <div class="col-11 ml-1 gray-70 wrap small">
            {{generalInformationModal?.value['segment']?.value ? generalInformationModal?.value['segment']?.value
            :'none' | translate | titlecase }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-6">
    <div class="row ml-1 h-100 border-left border-left-dotted">
      <h4 class="col-12 font-weight-bold margin-top-20">
        <fa-icon class="mr-1" [icon]="['far', 'comment-alt-lines']"></fa-icon>
        {{ "message" | translate }}:
      </h4>
      <div class="col-12 h-100 offset-0-5 gray-70">
        <textarea readonly>{{ generalInformationModal?.value['message'] }}</textarea>
      </div>
    </div>
  </div>
</div>



<div class="form-row border rounded visibleMobile w-100">
  <div class="col-sm-12 w-100">
    <div class="row ml-n1 h-100 w-100">
      <div class="col-12 h-19 d-flex align-items-center border-bottom border-bottom divLeft-n1 w-100">
        <div class="row ml-1 margin-top-bottom">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1 gray-40" [icon]="['far', 'envelope-open-text']"></fa-icon>
            {{ "titleEnvelope" | translate | titlecase }}:
          </h4>
          <div class="col-11 offset-0-5 gray-70 wrap small">
            {{ generalInformationModal?.value['titleEnvelope'] }}
          </div>
        </div>
      </div>
      <div
        class="col-6 h-17 d-flex align-items-center border-bottom divLeft-n1">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1 gray-40" [icon]="['far', 'globe']"></fa-icon>
            {{ "language" | translate | titlecase }}:&nbsp;
          </h4>
          <div class="gray-70 wrap small">
            {{ generalInformationModal?.value['language']?.value }}
          </div>
        </div>
      </div>
      <div class="col-6 h-17 d-flex align-items-center border-bottom">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1 gray-40" [icon]="['far', 'hourglass-half']"></fa-icon>
            {{ "expiration" | translate | titlecase }}:&nbsp;
          </h4>
          <div class="gray-70 wrap small">
            {{ generalInformationModal?.value['expiration']?.singleDate?.formatted ? generalInformationModal?.value['expiration']?.singleDate?.formatted
            : 'noneExpiration' | translate | titlecase }}
          </div>
        </div>
      </div>
      <div class="col-12 h-17 d-flex align-items-center border-bottom">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1 gray-40" [icon]="['far', 'key']"></fa-icon>
            {{ "authentication" | translate | titlecase }}:&nbsp;
          </h4>
          <div class="gray-70 wrap small">
            {{ accessAuthenticationText | titlecase }}
          </div>
        </div>
      </div>
      <div class="col-12 h-25 d-flex align-items-center border-bottom divLeft-n1">
        <div class="row ml-1 margin-top-bottom">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1 gray-40" [icon]="['far', 'file-alt']"></fa-icon>
            {{ "document" | translate | titlecase }}:
          </h4>
          <div class="row documents">
            <div class="col-11 offset-0-5 gray-70 wrap small"
              *ngFor="let file of generalInformationModal?.value['archives']">
              {{ file.name }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 h-17 d-flex align-items-center border-bottom divLeft-n1" *ngIf="!isSignFreemium">
        <div class="row ml-1">
          <h4 class="font-weight-bold">
            <fa-icon class="mr-1 gray-40" [icon]="['far', 'folder']"></fa-icon>
            {{ "segment" | translate | titlecase }}:&nbsp;
          </h4>
          <div class="gray-70 wrap small">
            {{generalInformationModal?.value['segment']?.value ? generalInformationModal?.value['segment']?.value
            :'none' | translate | titlecase }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12">
    <div class="row ml-1 h-100">
      <h4 class="col-12 font-weight-bold margin-top-20 margin-left-neg-5">
        <fa-icon class="mr-1 gray-40" [icon]="['far', 'comment-alt-lines']"></fa-icon>
        {{ "message" | translate | titlecase }}:
      </h4>
      <div class="col-12 offset-0-5 gray-70 margin-right-20 margin-bottom-20">
        <textarea readonly>{{ generalInformationModal?.value['message'] }}</textarea>
      </div>
    </div>
  </div>
</div>
